const $ = jQuery;

$( document ).ready(function() {
    console.log( "ready!" );

    if($(".custom-wrap-section").length){
        
        $(".custom-wrap-section").each(function(){
            $(this).removeClass('custom-wrap-section');
            $(this).parent().addClass('custom-wrap-section');
        });

        $(".custom-wrap-section").wrapAll('<div id="home-sections-bg-wrapper"></div>');
    }
});